import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Layout from './components/Layout';

// SkillUpgrade Pages
import SkillUpgrade from './pages/SkillUpgrade/SkillUpgrade';
import Courses from './pages/SkillUpgrade/Courses';
import EnrollForm from './pages/SkillUpgrade/EnrollForm';
import Programs from './pages/SkillUpgrade/Programs';
import Internships from './pages/SkillUpgrade/Internships'; 

// Main Pages
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services/Services';
import Industries from './pages/Industries/Industries';
import Careers from './pages/Careers';
import Contact from './pages/Contact';

// Solutions Pages
import Solutions from './pages/Solutions/Solutions';
import TechStack from './pages/Solutions/TechStack';
import Collaborations from './pages/Solutions/Collaborations';
import InnovationHub from './pages/Solutions/InnovationHub';
import AiIntegrations from './pages/Solutions/AiIntegrations';

// Company Info Pages
import Infrastructure from './pages/Infrastructure/Infrastructure';
import Mission from './pages/Mission/Mission';
import Vision from './pages/Vision/Vision';

// Industry Subpages
import ConsumerTech from './pages/Industries/ConsumerTech';
import HumanResources from './pages/Industries/HumanResources';
import ArtificialIntelligence from './pages/Industries/ArtificialIntelligence';
import Banking from './pages/Industries/Banking';
import Healthcare from './pages/Industries/Healthcare';
import Travel from './pages/Industries/Travel';
import MediaEntertainment from './pages/Industries/MediaEntertainment';

// Services Subpages
import AiMl from './pages/Services/AiMl';
import CloudDevOps from './pages/Services/CloudDevOps';
import CustomSoftware from './pages/Services/CustomSoftware';
import DataAnalytics from './pages/Services/DataAnalytics';
import HR from './pages/Services/HR';
import ItConsulting from './pages/Services/ItConsulting';
import Maintenance from './pages/Services/Maintenance';
import UiUxDesign from './pages/Services/UiUxDesign';
import WebMobile from './pages/Services/WebMobile';

import './App.css';

const AppRoutes = () => {
  const renderWithLayout = (Component) => (
    <Layout>
      <Component />
    </Layout>
  );

  return (
    <Routes>
      {/* Main Pages */}
      <Route path="/" element={renderWithLayout(Home)} />
      <Route path="/home" element={renderWithLayout(Home)} />
      <Route path="/about" element={renderWithLayout(About)} />
      <Route path="/services" element={renderWithLayout(Services)} />
      <Route path="/industries" element={renderWithLayout(Industries)} />
      <Route path="/careers" element={renderWithLayout(Careers)} />
      <Route path="/contact" element={renderWithLayout(Contact)} />

      {/* SkillUpgrade */}
      <Route path="/skillupgrade" element={renderWithLayout(SkillUpgrade)} />
      <Route path="/skillupgrade/courses" element={renderWithLayout(Courses)} />
      <Route path="/skillupgrade/programs" element={renderWithLayout(Programs)} />
      <Route path="/skillupgrade/internships" element={renderWithLayout(Internships)} /> {/* Added */}
      <Route path="/skillupgrade/enroll" element={renderWithLayout(EnrollForm)} />

      {/* Solutions */}
      <Route path="/solutions" element={renderWithLayout(Solutions)} />
      <Route path="/solutions/tech-stack" element={renderWithLayout(TechStack)} />
      <Route path="/solutions/collaborations" element={renderWithLayout(Collaborations)} />
      <Route path="/solutions/innovation-hub" element={renderWithLayout(InnovationHub)} />
      <Route path="/solutions/ai-integrations" element={renderWithLayout(AiIntegrations)} />

      {/* Company Info */}
      <Route path="/infrastructure" element={renderWithLayout(Infrastructure)} />
      <Route path="/vision" element={renderWithLayout(Vision)} />
      <Route path="/mission" element={renderWithLayout(Mission)} />

      {/* Services */}
      <Route path="/services/ai-ml" element={renderWithLayout(AiMl)} />
      <Route path="/services/cloud-devops" element={renderWithLayout(CloudDevOps)} />
      <Route path="/services/custom-software" element={renderWithLayout(CustomSoftware)} />
      <Route path="/services/data-analytics" element={renderWithLayout(DataAnalytics)} />
      <Route path="/services/human-resources" element={renderWithLayout(HR)} />
      <Route path="/services/it-consulting" element={renderWithLayout(ItConsulting)} />
      <Route path="/services/maintenance" element={renderWithLayout(Maintenance)} />
      <Route path="/services/ui-ux" element={renderWithLayout(UiUxDesign)} />
      <Route path="/services/web-mobile" element={renderWithLayout(WebMobile)} />

      {/* Industries */}
      <Route path="/industries/consumer-tech" element={renderWithLayout(ConsumerTech)} />
      <Route path="/industries/human-resources" element={renderWithLayout(HumanResources)} />
      <Route path="/industries/artificial-intelligence" element={renderWithLayout(ArtificialIntelligence)} />
      <Route path="/industries/banking" element={renderWithLayout(Banking)} />
      <Route path="/industries/healthcare" element={renderWithLayout(Healthcare)} />
      <Route path="/industries/travel" element={renderWithLayout(Travel)} />
      <Route path="/industries/media-entertainment" element={renderWithLayout(MediaEntertainment)} />
    </Routes>
  );
};

function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

export default App;
